import api from "../api/axiosInstance";

// ✅ Fetch all shortlists
export const fetchShortlistsMine = async () => {
  try {
    const response = await api.get(`/shortlist/mine`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shortlists:", error);
    throw error;
  }
};

//fetch shortlist recived to me
export const fetchShortlistsReceived = async () => {
  try {
    const response = await api.get(`/shortlist/received`);
    return response.data;
  } catch (error) {
    console.error("Error fetching received shortlists:", error);
    throw error;
  }
};

// get all notifications for a user
export const fetchNotifications = async (profileId) => {
  try {
    const response = await api.get(`/notifications/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

// mark notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await api.put(`/notifications/read/${notificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};